import {Box, Divider, Grid, Typography} from "@mui/material";
import {Fragment} from "react";
import {LABEL_DOWNLOAD_URL_PREFIX} from "../../Utils/apiUrl";

export const WordPressQuoteRatingPackage = ({
                                                packageRate,
                                                redirectToApp,
                                                lng,
                                                NoRate,
                                                RegisterLink,
                                                Coupon,
                                                Feedback
                                            }) => {

    if (packageRate?.length === 0) {
        return (
            <Fragment>
                <Grid size={{xs: 12}}>
                    <NoRate/>
                </Grid>
                <Grid size={{xs: 12}}>
                    <Feedback/>
                </Grid>
                <Grid size={{xs: 12}}>
                    <RegisterLink/>
                </Grid>
                <Grid size={{xs: 12}}>
                    <Coupon/>
                </Grid>
                {redirectToApp()}
            </Fragment>
        )
    }

    return (
        <Fragment>
            <Grid size={{xs: 12}}>
                <Grid container spacing={2}>
                    {
                        packageRate?.length > 0 &&
                        <>
                            <Grid size={{xs: 4}}>
                                <Typography>
                                    {lng === 'cn' ? '承运商' : "Carrier"}
                                </Typography>
                            </Grid>
                            <Grid size={{xs: 4}}>
                                <Typography>
                                    {lng === 'cn' ? '运输天数' : "Transit Days"}
                                </Typography>
                            </Grid>
                            <Grid size={{xs: 4}}>
                                <Typography>
                                    {lng === 'cn' ? '费用' : "Cost"}
                                </Typography>
                            </Grid>
                            <Grid size={{xs: 12}}>
                                <Divider/>
                            </Grid>
                            {
                                packageRate?.map((rate, index) => (
                                    <Fragment key={index}>
                                        <Grid size={{xs: 4}}>
                                            <Box>
                                                <img src={`${LABEL_DOWNLOAD_URL_PREFIX}${rate?.icon_uri}`} alt="icon"
                                                     width='40px'/>
                                            </Box>
                                        </Grid>
                                        <Grid size={{xs: 4}}>
                                            <Typography>
                                                {rate?.shipRange || '2 - 10'} days
                                            </Typography>
                                        </Grid>
                                        <Grid size={{xs: 4}}>
                                            <Typography>
                                                $ {(+rate?.finalTotalAmount?.value)?.toFixed(2)} {rate?.finalTotalAmount?.currency}
                                            </Typography>
                                        </Grid>
                                    </Fragment>
                                ))
                            }
                        </>
                    }
                </Grid>
            </Grid>
            <Grid size={{xs: 12}}>
                <Typography>
                    {lng === 'cn' ? '预估费用仅供参考。' : "The estimated cost is for reference only."}
                </Typography>
            </Grid>
            <Grid size={{xs: 12}}>
                <Feedback/>
            </Grid>
            <Grid size={{xs: 12}}>
                <RegisterLink/>
            </Grid>
            <Grid size={{xs: 12}}>
                <Coupon/>
            </Grid>
            {
                redirectToApp()
            }
        </Fragment>
    )
}